import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export const RevealLines = ({ lines, className = "", delay = 0 }) => (
  <span className="block">
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          className={`block ${className}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: EASE, delay: i * 0.08 },
  }),
};

export const Reveal = ({ children, className = "", i = 0, once = true }) => (
  <motion.div
    className={className}
    variants={fadeUp}
    custom={i}
    initial="hidden"
    whileInView="show"
    viewport={{ once, amount: 0.3 }}
  >
    {children}
  </motion.div>
);
